/// <amd-module name="Search/Shared/Components/PivotCommands" />
export * from "./PivotCommands/index";
